import React from "react";
import Navbar from "../layout/Navbar";
import ChoosePlan from "./ChoosePlan";

function PlanSection() {

  return (
    <>
      <Navbar />
      <ChoosePlan />
    </>
  );
}

export default PlanSection;
